import React, { useEffect, useState } from 'react'
import { useStoreActions } from '../../model/hooks'
import { useNavigate } from 'react-router'
import { PoolData, PoolOverview } from '../charts/chartsApi'
import { useWalletContext } from '../WalletContext'
import { useCustomBreakpoint } from '../charts/Charts'
import { CalendarIcon } from '../../svgIcons/CalendarIcon'
import { CompletedIcon } from '../../svgIcons/CompletedIcon'
import { InProgressIcon } from '../../svgIcons/InProgressIcon'
import { LockIcon } from '../../svgIcons/LockIcon'

const allHeaderCells = [
    { colName: 'PERIOD', title: 'Period', helptip: undefined },
    { colName: 'REWARD', title: 'Reward', helptip: undefined },
    { colName: 'STATUS', title: 'Status', helptip: undefined }
]

type IncentiveRow = { from: string; to: string; to1: string; status: 'future' | 'completed' | 'in progress' | 'finalizing' }
// const data = [
//     { from: 1708552920000, to: 1709762520000 },
//     { from: 1709762520000, to: 1710972120000 },
//     { from: 1710972120000, to: 1712178120000 },
//     { from: 1712178120000, to: 1713387720000 },
//     { from: 1713387720000, to: 1714597320000 },
//     { from: 1714597320000, to: 1715806920000 }
// ] as { from: number; to: number }[]

const dataHardCoded = [
    { from: 'Feb 22', to: 'Mar 7', to1: 'Mar 8', status: 'completed' },
    { from: 'Mar 7', to: 'Mar 21', to1: 'Mar 22', status: 'completed' },
    { from: 'Mar 21', to: 'Apr 4', to1: 'Apr 5', status: 'completed' },
    { from: 'Apr 4', to: 'Apr 18', to1: 'Apr 19', status: 'completed' },
    { from: 'Apr 18', to: 'May 2', to1: 'May 3', status: 'completed' },
    { from: 'May 2', to: 'May 16', to1: 'May 17', status: 'in progress' }
] as IncentiveRow[]

// function getDateStatus(startDate: number, endDate: number): 'future' | 'completed' | 'in progress' | 'finalizing' {
//     const currentTime = Date.now()
//     if (currentTime < startDate) {
//         return 'future'
//     } else if (currentTime > endDate + 3600 * 24 * 1000) {
//         return 'completed'
//     } else if (currentTime > endDate) {
//         return 'finalizing'
//     } else {
//         return 'in progress'
//     }
// }

export const IncentiveProgressionTable = () => {
    const { walletAddress: connectedAddress, connect, networkName: network } = useWalletContext()
    const screenSize = useCustomBreakpoint()
    const navigate = useNavigate()
    const loadTokens = useStoreActions((actions) => actions.tokens.loadTokens)
    // const [data, setData] = useState([] as (PoolOverview & PoolData)[])
    const [poolOverviews, setPoolsOverview] = useState(undefined as unknown as (PoolOverview & PoolData)[])
    const [searchTerm, setSearchTerm] = useState('')
    const [isInputFocused, setIsInputFocused] = useState(false)
    const [isNoResults, setIsNoResults] = useState(false)
    const [poolsList, setPoolsList] = useState({} as Record<string, (PoolOverview & PoolData)[]>)
    const [incentivePoolsData, setInceintivePoolsData] = useState([] as (PoolOverview & PoolData)[])
    const [openAPRList, setOpenAPRList] = useState({} as Record<string, boolean>)
    const [mainPools, setMainPools] = useState([] as string[])
    const [columns, setColumns] = useState([] as string[])

    // useEffect(() => {
    //     if (poolOverviews) updateData()
    // }, [poolOverviews])

    // useEffect(() => {
    //     updateData()
    // }, [searchTerm])

    useEffect(() => {
        const newCols = getColumns()
        setColumns(newCols)
    }, [screenSize])

    useEffect(() => {
        if (openAPRList && Object.keys(openAPRList).length > 0) sortPoolsData(poolOverviews)
    }, [openAPRList])

    useEffect(() => {
        loadTokens({ network: 'mainnet-alpha' })
    }, [])

    // useEffect(() => {
    //     if (possiblePools.length > 0) loadAllPoolsData()
    //     // loadOverview()
    // }, [tokenAddress, possiblePools])

    // async function loadAllPoolsData() {
    //     const response = await loadPoolsData()

    //     const promises: any[] = []
    //     response.map((pool) => promises.push(loadPoolOverviewData(pool.poolkey)))

    //     const overviews: PoolOverview[] = await Promise.all(promises)
    //     const combinedData: any[] = []
    //     response.map((item, index) => {
    //         const isMatch = possiblePools.some((pool) => [item.token0.address, item.token1.address].every((token) => pool.includes(token)))
    //         if (!isMatch) return

    //         if ((tokenAddress && item.token0.address.toLowerCase() === tokenAddress?.toLowerCase()) || item.token1.address.toLowerCase() === tokenAddress?.toLowerCase())
    //             combinedData.push({ ...overviews[index], ...response[index] })
    //         else if (!tokenAddress) combinedData.push({ ...overviews[index], ...response[index] })
    //     })

    //     setPoolsOverview(combinedData)
    //     sortPoolsData(combinedData)
    // }

    function sortPoolsData(data: (PoolOverview & PoolData)[]) {
        const sortedPoolsData = {} as Record<string, (PoolOverview & PoolData)[]>
        const dataCopy = [...data]
        dataCopy.sort((a, b) => {
            if (a.tvl > b.tvl) return -1
            if (b.tvl > a.tvl) return 1
            return 0
        })

        dataCopy.forEach((item) => {
            if (!sortedPoolsData[`${item.token0.address}_${item.token1.address}`]) return (sortedPoolsData[`${item.token0.address}_${item.token1.address}`] = [{ ...item }])
            sortedPoolsData[`${item.token0.address}_${item.token1.address}`].push(item)
        })

        setPoolsList(sortedPoolsData)
        const mainPoolKeys = [] as string[]
        const incentiveMainPools = [] as (PoolOverview & PoolData)[]

        Object.values(sortedPoolsData).map((item, index) => {
            mainPoolKeys.push(item[0].poolkey)
            const isOpen = openAPRList && openAPRList[`${item[0].token0.address}_${item[0].token1.address}`]
            if (isOpen) {
                return item.forEach((it) => {
                    incentiveMainPools.push(it)
                })
            } else return incentiveMainPools.push(item[0])
        })
        setMainPools(mainPoolKeys)

        setInceintivePoolsData(incentiveMainPools)
    }

    // function updatePoolsWithoutBannedTokens(data: (PoolOverview & PoolData)[]) {
    //     const newData = [] as (PoolOverview & PoolData)[]

    //     data.map((item) => {
    //         if (item.poolkey.toLowerCase() !== '0x452add90bc93d620f2ea539fa16276b437445314e76ed23b17ac2e67395c99'.toLowerCase()) newData.push(item)
    //     })
    //     setData(newData)
    // }

    // function updateData() {
    //     if (!poolOverviews) return

    //     let overviews = [...poolOverviews]
    //     if (searchTerm) {
    //         const searchTermLowerCased = searchTerm.toLowerCase()
    //         overviews = poolOverviews.filter(
    //             (option) =>
    //                 option.poolkey.toLowerCase().includes(searchTermLowerCased) ||
    //                 option.token0.symbol.toLowerCase().includes(searchTermLowerCased) ||
    //                 option.token0.address.toLowerCase().includes(searchTermLowerCased) ||
    //                 option.token1.symbol.toLowerCase().includes(searchTermLowerCased) ||
    //                 option.token1.address.toLowerCase().includes(searchTermLowerCased)
    //         )
    //     }
    //     const poolsData: (PoolOverview & PoolData)[] = [...overviews]
    //     poolsData.sort((a, b) => {
    //         if (a.tvl > b.tvl) return -1
    //         if (b.tvl > a.tvl) return 1
    //         return 0
    //     })

    //     if (poolsData.length === 0) setIsNoResults(true)
    //     else setIsNoResults(false)

    //     if (!searchTerm) return updatePoolsWithoutBannedTokens(poolsData)
    //     else setData(poolsData)
    // }

    function getColumns() {
        return ['PERIOD', 'REWARD', 'STATUS']
    }

    // function getToken1Name(pool: PoolOverview & PoolData) {
    //     const symbol = pool.token0.symbol === 'WSTETH' ? 'wstETH' : pool.token0.symbol
    //     return symbol
    // }

    // function getToken2Name(pool: PoolOverview & PoolData) {
    //     const symbol = pool.token1.symbol === 'WSTETH' ? 'wstETH' : pool.token1.symbol
    //     return symbol
    // }

    function getTableHeaderCellNames(): { title: string; helptip?: string }[] {
        const existingColumns = columns
        const columnsToUse: { title: string; helptip?: string | undefined }[] = []

        existingColumns.map((existingColumnName, index) => {
            const col = allHeaderCells.find((item) => item.colName === existingColumnName)
            if (col) columnsToUse.push(col)
        })

        //console.log("YSYS existingColumns=",existingColumns," columnsToUse=",columnsToUse)
        return columnsToUse
    }

    function renderHeaderTH(headerInfo: { title: string; helptip?: string }, index: number) {
        return (
            <th className={`text-white text-[18px]  font-[600] ${index === 0 ? 'lg:pl-[50px] pl-[16px]' : ''}`} key={headerInfo.title}>
                <div className={`${headerInfo.title === 'Status' ? 'justify-end' : ''} flex relative items-center lg:mr-0 mr-6 ${headerInfo.title === 'Reward' ? ' pr-3' : ''}`}>
                    <span>{headerInfo.title}</span>
                    <div className='ml-2 group inline-flex'>
                        {/* {headerInfo.helptip && <HelptipIcon className='text-[#8387A5] w-4 h-4' />} */}
                        <span className='left-[-100px] lg:left-[-20px] top-[-45px] w-[200px] group-hover:visible invisible group-hover:opacity-100 transition-opacity bg-[#242C58] text-sm text-gray-100 rounded-md absolute opacity-0 top-[30px] p-3 z-[1]'>
                            {headerInfo.helptip}
                        </span>
                    </div>
                </div>
            </th>
        )
    }

    function renderTableHeader() {
        const headerColumns = getTableHeaderCellNames()
        const headerTHS = headerColumns.map(renderHeaderTH)
        return (
            <thead className=''>
                <tr className='border-b-[20px] border-transparent'>{headerTHS}</tr>
            </thead>
        )
    }

    function renderLoadingRow() {
        return (
            <tr>
                <td>
                    <div className='lg:ml-[50px] ml-[16px] h-[30px] w-[80px] bg-white animate-pulse rounded-md' />
                </td>
                <td>
                    <div className='h-[30px] w-[80px] bg-white animate-pulse rounded-md' />
                </td>
                <td>
                    <div className='flex items-center'>
                        <div className='h-[30px] w-[80px] bg-white animate-pulse rounded-md' />
                        <div className='h-[30px] w-[1px] bg-white animate-pulse mx-3' />
                        <div className='flex flex-col'>
                            <div className='h-[30px] w-[80px] mb-2 bg-white animate-pulse rounded-md' />
                            <div className='h-[30px] w-[80px] bg-white animate-pulse rounded-md' />
                        </div>
                    </div>
                </td>
                <td>
                    <div className='flex items-center'>
                        <div className='h-[30px] w-[80px] bg-white animate-pulse rounded-md' />
                        <div className='h-[30px] w-[80px] bg-white animate-pulse rounded-md ml-2' />
                    </div>
                </td>
            </tr>
        )
    }

    function renderTableBody() {
        let rows: JSX.Element[] = []

        rows = dataHardCoded.map((item, index) => renderTableRow(item, index))
        return <tbody className='shadow-2xl lg:shadow-none rounded-[16px]'>{rows}</tbody>
    }

    function renderPeriod(data: IncentiveRow) {
        return (
            <td className='lg:pl-[50px] pl-[16px] pr-4'>
                <div className='flex items-center'>
                    <CalendarIcon className='w-[24px] h-[24px] mr-2' />
                    <span className='text-white flex-shrink-0 font-bold lg:text-[18px] text-[12px]'>{data.from}</span>
                    <span className='lg:mx-2 mx-1 text-[#D6D6D6] lg:text-[18px] text-[12px]'>{'to'}</span>
                    <span className='text-white flex-shrink-0 font-bold lg:text-[18px] text-[12px]'>{data.to}</span>
                </div>
            </td>
        )
    }

    function getStatusText(data: IncentiveRow) {
        const status = data.status
        if (status === 'completed') return 'Completed'
        if (status === 'future') return 'Not started'
        if (status === 'in progress') return 'In progress'
        if (status === 'finalizing') return 'Finalizing'
    }

    function getStatusBGColor(data: IncentiveRow) {
        const status = data.status
        if (status === 'completed') return '#607BFF'
        if (status === 'in progress') return '#00C853'
        if (status === 'future') return '#6F6E8F'
        if (status === 'finalizing') return '#00C853'
    }

    function getClaimTimeText(data: IncentiveRow) {
        const status = data.status
        if (status === 'completed') return 'Claim available'
        if (status === 'in progress' || status === 'future' || status === 'finalizing') return 'Claim available on ' + data.to1
        // if (status === 'future') return '#6F6E8F'
    }

    function getStatusIcon(data: IncentiveRow) {
        const status = data.status
        if (status === 'completed') return <CompletedIcon className='w-[12px] h-[12px]' />
        if (status === 'in progress' || status === 'finalizing') return <InProgressIcon className='w-[12px] h-[12px]' />
        if (status === 'future') return <LockIcon className='w-[16px] h-[18px]' />
    }

    function renderReward(data: IncentiveRow) {
        return (
            <td className={`pr-4 lg:min-w-[200px]`}>
                {/* <span>{'Reward'}</span> */}
                <div className='flex items-center lg:flex-row flex-col'>
                    <div className='flex items-center'>
                        <div style={{ background: getStatusBGColor(data) }} className={`text-white py-1 lg:px-2 px-1 h-full rounded-[8px] flex items-center justify-center`}>
                            {getStatusIcon(data)}
                            <span className='ml-1 lg:text-[16px] text-[12px]'>{getStatusText(data)}</span>
                        </div>
                    </div>
                    {/* <span className='ml-2' style={{ color: status === 'completed' ? 'white' : '#D6E7FF' }}>
                        {getClaimTimeText(data)}
                    </span> */}
                </div>
            </td>
        )
    }

    function renderStatus(data: IncentiveRow) {
        const status = data.status

        return (
            <td className='pr-4'>
                <span className='flex justify-end lg:text-[18px] text-[12px]' style={{ color: status === 'completed' ? 'white' : '#D6E7FF' }}>
                    {getClaimTimeText(data)}
                </span>
            </td>
        )
    }

    function renderTableRow(data: IncentiveRow, index: number) {
        return (
            <>
                <tr key={index} className={`lg:pl-[50px] pl-[16px] py-[18px] pr-[32px] h-[70px] px-[30px] pt-[24px] pb-[17px]  border-[#0C3F6D] border-b-[1px]`}>
                    {renderPeriod(data)}
                    {renderReward(data)}
                    {renderStatus(data)}
                </tr>
            </>
        )
    }
    function renderDataTable() {
        return (
            <table className='mt-[40px] bg-transparent z-[20] tablerounded w-full'>
                {renderTableHeader()}
                {renderTableBody()}
            </table>
        )
    }

    return <>{renderDataTable()}</>
}
